import { useDesktopMediaQuery, useMobileMediaQuery } from "@media-query";
import { StackActions, useNavigation } from "@react-navigation/native";
import { getAuthSelector } from "app/modules/login/reducer/selectors";
import { Block } from "app/shared/components/blocks/block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import { spacing } from "app/shared/styles/spacing";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ScrollView, useWindowDimensions } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoyaltyLinkWebviewRequest } from "../reducer/actions";
import { getLoyaltyLinkWebviewSelector } from "../reducer/selectors";

const PVOneWebViewComponent = () => {
  const { t } = useTranslation();
  const { dispatch } = useNavigation();
  const dispatchStore = useDispatch();

  const isDesktop = useDesktopMediaQuery();
  const isMobile = useMobileMediaQuery();
  const { height, width } = useWindowDimensions();

  const responseLinkStore = useSelector(getLoyaltyLinkWebviewSelector);
  const statusLogin = useSelector(getAuthSelector);

  const [finalUrl, setFinalUrl] = React.useState<string>("");
  const onCancel = React.useCallback(() => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  }, [dispatch]);

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => onCancel(),
    },
    {
      name: t("FUNC_PV_ONE"),
      onPressSubtitle: () => {},
    },
  ];

  const captureUrl = React.useCallback(() => {
    console.log("captureUrl: ", finalUrl);
    // console.log("statusLogin: ", statusLogin);
    if (!statusLogin) {
      onCancel();
      return;
    }
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onCancel, statusLogin]);

  React.useEffect(() => {
    dispatchStore(fetchLoyaltyLinkWebviewRequest());
  }, [dispatchStore]);

  React.useEffect(() => {
    console.log("responseLinkStore: ", responseLinkStore);
    if (responseLinkStore) {
      setFinalUrl(responseLinkStore);
    }
  }, [responseLinkStore]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("SETTING_PV_ONLINE_BANKING")} subtitles={subtitlesArrays} />
        <Block pv={spacing.medium} ph={isDesktop ? "5%" : 0} flex={1} center bottom>
          {finalUrl.length ? (
            <iframe
              src={finalUrl}
              width={isMobile ? width - 20 : width - 320}
              height={height - 190}
              style={{ border: 0, borderRadius: 10, bottom: 0, scrollbarColor: "fff" }}
              onLoadCapture={captureUrl}
              loading="lazy"
            />
          ) : (
            <></>
          )}
        </Block>
      </ScrollView>
    </Block>
  );
};

export default PVOneWebViewComponent;
